import { createSlice } from '@reduxjs/toolkit'

export const yearSlice = createSlice({
  name: 'selectedYear',
  initialState: {
    year: '2022',
    displayYear: '2022'
  },
  reducers: {
    increment: (state) => {
      state.year += 1
    },
    decrement: (state) => {
      state.year -= 1
    },
    changeYearByAmount: (state, action) => {
      console.log('year redux');
      state.year = action.payload
    },
    setDisplayYear: (state, action) => {
      console.log('year redux');
      state.displayYear = action.payload
    },
  },
})

export const { increment, decrement, changeYearByAmount, setDisplayYear } = yearSlice.actions

export default yearSlice.reducer